import { Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { conf, Relationship, RelSide, Resource, RelType } from 'src/config';
import DataGrid from 'src/domains/query/components/DataGrid';
import { LIST } from 'src/domains/types';
import * as types from '../../types';
import _ from 'lodash';

const Lookup: React.FC<{
    rel: Relationship,
    open: boolean,
    inverse: boolean,
    local: boolean,
    onClose: () => void,
    onSelect: (id: types.ID[]) => void,
    lockedAreNonSelectable: boolean,
}> = ({
    rel,
    open,
    inverse,
    local,
    onClose,
    onSelect,
    lockedAreNonSelectable
}) => {
        const [ids, setIds] = useState<types.ID[]>([]);
        const resourceName = inverse ? rel.resource : rel.related;

        useEffect(() => {
            setIds([])
        }, [open]);

        const handleAccept = () => {
            onSelect(ids);
            onClose();
        }

        const onEsc: React.KeyboardEventHandler<HTMLDivElement> = (e: React.KeyboardEvent<HTMLDivElement>) => {
            if (e.key === 'Escape') {
                onClose();
            }
        }

        return (
            <Dialog
                open={open}
                maxWidth='xl'
                onKeyDown={onEsc}
            >
                <DialogTitle>{resourceName}</DialogTitle>
                <DialogContent>
                    <DataGrid
                        conf={{
                            resourceName,
                            type: LIST
                        }}
                        local={local}
                        onSelect={ids => setIds(ids)}
                        multiple={
                            rel.metaType === RelType.MANY_TO_MANY || (rel.metaType === RelType.MANY_TO_ONE && inverse)
                        }
                        lockedAreNonSelectable={lockedAreNonSelectable}
                    />
                </DialogContent>
                <DialogActions>
                    {
                        !_.isEmpty(ids) &&
                        <Button variant='contained' onClick={handleAccept}>
                            {'Ok'}
                        </Button>
                    }
                    <Button variant='contained' onClick={onClose}>
                        {'Close'}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

export default Lookup;
